/**
 *
 * @module telemetryClientEndpoint
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef TelemetryClientEndpoint
 * @type {Object}
 *
 * @property {String} postEvent
 *
 */

/**
 *
 * @enum
 * @type {TelemetryClientEndpoint}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    postEvent: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    dustEvent: null
});



// WEBPACK FOOTER //
// ./src/services/internal/telemetry/telemetryClientEndpoint.js